import { css } from '@emotion/react';
import { AI_USAGE_GUIDE_URL } from '@/const';
import InfoIcon from '@/assets/images/info_icon.svg';

interface AiUsageNoticeProps {
  className?: string;
}

function AiUsageNotice({ className }: AiUsageNoticeProps) {
  return (
    <div css={NoticeContainer} className={className}>
      <img src={InfoIcon} alt="info" css={InfoIconStyle} />
      <div css={TextContainer}>
        <p css={NoticeText}>AI 생성 결과물은 개인/상업용 모두 사용 가능해요.</p>
        <a href={AI_USAGE_GUIDE_URL} target="_blank" rel="noopener noreferrer" css={UsageLink}>
          (이용 안내)
        </a>
      </div>
    </div>
  );
}

export default AiUsageNotice;

const NoticeContainer = css`
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1 1 295px;
  min-width: 295px;
`;

const InfoIconStyle = css`
  width: 16px;
  height: 16px;
`;

const TextContainer = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0;
  flex: 1;
`;

const NoticeText = css`
  font-size: 12px;
  line-height: 16px;
  color: #626262;
  font-family: Pretendard;
  font-weight: 400;
  white-space: nowrap;
  margin: 0;
`;

const UsageLink = css`
  font-size: 12px;
  line-height: 16px;
  color: #555;
  font-family: Pretendard;
  font-weight: 400;
  text-align: center;
  text-decoration: underline;
  padding: 4px;
  border-radius: 8px;
  white-space: nowrap;
`;
